import Vue from "vue";

/**
 * Font Awesome
 */
import FontAwesome from "./plugins/fontAwesome";
Vue.use(FontAwesome);

/**
 * GlobalComponents
 */
import global from "@/plugins/globalComponents";
Vue.use(global);

/**
 * JsonFormatter
 */
import JsonViewer from "vue-json-viewer";
Vue.use(JsonViewer);

/*
 * Initial instance of Vue
 */
import i18n, { changeLocale } from "@/lang";
import vuetify from "@/plugins/vuetify";
import store from "@/store";
import * as a from "@/store/modules/ApplicationModule/actions";
import App from "./App.vue";
import { LocalStorageManager, LocalStorageRequests } from "./plugins/LocalStorageManager";
import router from "./router";
Vue.config.productionTip = true;

new Vue({
    store,
    router,
    i18n,
    vuetify,
    async beforeCreate() {
        let languageFromStorage = LocalStorageManager.Read(LocalStorageRequests.LocaleLanguage);
        if (languageFromStorage) await changeLocale(languageFromStorage);
        else await changeLocale("en");
        this.$store.dispatch(a.APP_BOOTSTRAP);
    },
    render: (h) => h(App),
}).$mount("#app");
